module.exports = __webpack_public_path__ + "img/edit-box-green.cff25e58.svg";